// 利用規約
export const TERMS_URL: string = 'https://qlean-works.jp/terms'

// プライバシーポリシー
export const PRIVACY_POLICY_URL: string = 'https://qlean-works.jp/personal'
